import { QueryClient } from "@tanstack/react-query";

/**
 * Each workspace builds its own QueryClient (see `web/src/index.tsx` and `mobile/App.tsx`),
 * so shared non-React code (stores, interceptors) cannot import it directly. Register it at
 * boot to give that code access to the cache.
 */
let queryClient: QueryClient | undefined;

export const setQueryClient = (client: QueryClient) => {
  queryClient = client;
};

/**
 * Drop every cached response. Member-scoped data (member, requests, bell) must not survive a
 * session: `enabled: false` only stops refetching, it still serves the previous user's data.
 */
export const clearQueryCache = () => {
  queryClient?.clear();
};
